import axios from 'axios';

// Get base URL from environment variables
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

console.log('[axios] Setting up axios with base URL:', API_BASE_URL);

// Create axios instance with custom configuration
const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Increase to 30 seconds timeout for all requests
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Add request interceptor for auth token
instance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add to headers
    if (token) {
      config.headers.token = token;
      console.log(`[axios] Adding token to request: ${token.substring(0, 10)}...`);
    } else {
      console.warn('[axios] No token found in localStorage for API request');
    }
    
    // Log the request for debugging
    console.log(`[axios] Making ${config.method?.toUpperCase()} request to ${config.url}`);
    
    // Special logging for POST and PUT requests
    if (config.method?.toUpperCase() === 'POST' || config.method?.toUpperCase() === 'PUT') {
      console.log(`[axios] ${config.method.toUpperCase()} REQUEST DETAILS:`, {
        url: config.url,
        headers: config.headers,
        data: config.data
      });
    }
    
    // Special logging for DELETE requests
    if (config.method?.toUpperCase() === 'DELETE') {
      console.log(`[axios] DELETE REQUEST DETAILS:`, {
        url: config.url,
        headers: config.headers,
        data: config.data
      });
    }
    
    return config;
  },
  (error) => {
    console.error('[axios] Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
instance.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx causes this function to trigger
    console.log(`[axios] Response from ${response.config.url}:`, {
      status: response.status,
      statusText: response.statusText
    });
    
    // For POST and PUT requests, add extra logging
    if (response.config.method?.toUpperCase() === 'POST' || response.config.method?.toUpperCase() === 'PUT') {
      console.log(`[axios] ${response.config.method.toUpperCase()} RESPONSE DETAILS:`, {
        url: response.config.url,
        status: response.status,
        data: response.data
      });
    }
    
    // For DELETE requests, add extra logging
    if (response.config.method?.toUpperCase() === 'DELETE') {
      console.log(`[axios] DELETE RESPONSE DETAILS:`, {
        url: response.config.url,
        status: response.status,
        data: response.data
      });
    }
    
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx cause this function to trigger
    if (error.response) {
      console.error(`[axios] Response error for ${error.config?.url || 'unknown URL'}:`, {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      });
    } else if (error.request) {
      console.error(`[axios] No response received for ${error.config?.url || 'unknown URL'}:`, error.request);
    } else {
      console.error(`[axios] Request setup error:`, error.message);
    }
    
    return Promise.reject(error);
  }
);

export default instance; 